<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';
import FormSidebarBtn from "./FormSidebarBtn.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    alwaysShow: Boolean
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const hasVariations = ref(false);

// --- Computed ---

const formState = computed(() => store.state[props.formId]);

const isArchived = computed(() => formState.value?.currentData?.isArchived);

const productTypeId = computed(() => formState.value?.currentData?.productTypeId);

const tableName = computed(() => formState.value?.tableName);

const id = computed(() => formState.value?.id);

const singularLabel = computed(() => formState.value?.singularLabel);

const componentId = computed(() => store.state.components.componentIds[tableName.value]);

const component = computed(() => {
    return store.state.components.items.find(obj => obj.id === componentId.value);
});

const hasAccess = computed(() => store.getters['user/access'](tableName.value, 'delete'));

const show = computed(() => {
    // Allows individual uses of the button to always be shown, such as the Website Editor's content sidebar
    if (props.alwaysShow) {
        return true;
    }

    return (
        id.value &&
        component.value?.deleteOption &&
        (isArchived.value || !component.value?.useArchive) &&
        tableName.value !== 'product_options' &&
        !hasVariations.value &&
        hasAccess.value
    );
});

// --- Watchers ---

watch(productTypeId, (value) => {
    if (tableName.value === 'product_options' && value) {
        store.dispatch('request/post', {
                url: 'api/ProductTypes/hasVariations',
                postData: {
                    typeId: value
                }
            })
            .then((obj) => {
                hasVariations.value = obj.data.count > 0;
            });
    } else {
        hasVariations.value = false;
    }
}, { immediate: true });

// --- Methods ---

const onClick = () => {
    store.dispatch(`${props.formId}/delete`, {
        siteTree: proxy.$route.name === 'siteTree'
    });
};
</script>

<template>
    <FormSidebarBtn v-if="show" @click.prevent.native="onClick" class="text-danger">
        <i class="me-2 bi bi-trash"/>
        Delete {{ singularLabel }}
    </FormSidebarBtn>
</template>